import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-black border-t border-yellow-700/20 mt-auto text-sm font-medium w-full">
      <div className="max-w-6xl mx-auto py-8 px-6 flex flex-col md:flex-row items-center justify-between gap-6 text-neutral-400">
        <div className="flex flex-wrap gap-6 justify-center items-center mb-4 md:mb-0">
          <a href="#about" className="hover:text-yellow-400 transition">About</a>
          <a href="#contact" className="hover:text-yellow-400 transition">Contact</a>
          <a href="https://linkedin.com/" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition">LinkedIn</a>
          <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition">Instagram</a>
          <Link to="/privacy" className="hover:text-yellow-400 transition">Privacy Policy</Link>
          <Link to="/tnc" className="hover:text-yellow-400 transition">Terms & Conditions</Link>
        </div>
        <div className="text-yellow-200 mb-2 md:mb-0">&copy; {new Date().getFullYear()} Crezar. All rights reserved.</div>
      </div>
    </footer>
  );
};

export default Footer;
